import { Button } from '@global-engineering-shared/gweb-material-ui';
import { capitalize } from 'lodash';
import React from 'react';

import useStyles from 'components/TimeRangeSelectButton/TimeRangeSelectButton.styles';
import { Dates } from 'context/DateProvider/DateProvider';
import { convertNowToISO } from 'context/DateProvider/utils/convertNowToISO';

type TimeRangeSelectButtonProps = {
  period: number;
  unit: 'minutes' | 'hours' | 'days';
  setDateTimeRange: React.Dispatch<React.SetStateAction<Dates>>;
};

const getPluralOrSingularUnit = (period: number, unit: 'minutes' | 'hours' | 'days') =>
  period === 1 ? unit.slice(0, -1) : unit;

const TimeRangeSelectButton = ({ period, unit, setDateTimeRange }: TimeRangeSelectButtonProps) => {
  const classes = useStyles();

  const unitAbbreviation = {
    minutes: 'm',
    hours: 'h',
    days: 'd',
  };

  return (
    <Button
      className={classes.button}
      variant="text"
      size="medium"
      onClick={() =>
        setDateTimeRange({
          from: convertNowToISO(`now-${period}${unitAbbreviation[unit]}`),
          to: convertNowToISO('now'),
        })
      }
    >
      {`Last ${period} ${capitalize(getPluralOrSingularUnit(period, unit))}`}
    </Button>
  );
};

export default TimeRangeSelectButton;
